import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export interface WaiterSwitchedPayload {
  waiterId: string;
}

export class WaiterSwitchedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(public readonly payload: WaiterSwitchedPayload) {
  }
}



